<div class="form-group">
    <input class="form-control" 
    [class.form-error] ="hasError || !isValid" 
    type="tel"
    maxlength="26"
    (keyup)="ibanPattern($event)"
    [(ngModel)] = "selectedIban"
    (blur) ="sendIban()"
    (focus)="focusInput($event)"
    id="selectedIban"
    autocomplete="off"
    required>
    <a class="saved-icon" >
        <img data-toggle="modal" data-target="#ibans" *ngIf= "!hideList" src="assets/img/Sheba-input-icon.svg" alt="">
        <span>IR</span>
    </a>
    <span class="floating-label">{{title}}</span>
    <span *ngIf="!optional" class="star">*</span>
    <span *ngIf="hasError && isValid" class="errorInput">پر کردن این فیلد الزامی است.</span>
    <span *ngIf="!isValid" class="errorInput">شماره شبا نامعتبر است.</span>
</div>

<div class="modal fade" tabindex="-1" role="dialog" id="ibans" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document" >
      <div class="modal-content" style="width: 95%">
        <div class="modal-body">
            <h1 class="header1">شبا های ذخیره شده: </h1>
            <div *ngIf="savedIbans === null || savedIbans.length === 0" style="margin: 50px;">
              <app-empty-box [title]="'شماره شبایی'"></app-empty-box>
            </div>
            <ul class="savedItem scroll" style="margin-top: 5px;">
              <li *ngFor="let iban of savedIbans;let i= index" (click)= "sendParentNotification(i)">
                <img class="letf-img" *ngIf= "iban.bank !== '' && iban.bank !== undefined" [src]='"assets/img/Banks/"+iban.bank+".png"' alt="">
                  <div class="h-div">
                      <span>{{iban.title}}</span>
                      <span class="farsiNumber">{{iban.iban}}</span>
                  </div>
              </li>
          </ul>
        </div>
        <div class="modal-footer simple-footer">
            <button class="btn" data-dismiss="modal">بستن</button>
        </div>
      </div>
    </div>
  </div>
